import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from "../comum/orgao.model";
import { Exercicio } from "../comum/exercicio.model";
import { ParcelamentoPagaRPPS } from './parcelamento-pagas-rpps.model';

export class ParcelamentoRPPS extends BaseResourceModel {
  constructor(
    public numero_parcelamento?: number,
    public mes?: number,
    public saldo_anterior?: number,
    public juros_atualizacao_monetaria?: number,
    public valor_previsto?: number,
    public valor_atualizado_previsto?: number,
    public valor_recebido?: number,
    public valor_atualizado_recebido?: number,
    public valor_multa?: number,
    public parcelas_pagas?: ParcelamentoPagaRPPS[],
    public saldo?: number,
    public saldo_atualizado?: number,
    public orgao?: Orgao,
    public exercicio?: Exercicio) {
    super();
  }
  static converteJson(json: any): ParcelamentoRPPS {
    return Object.assign(new ParcelamentoRPPS(), json);
  }
}